import React, { useState } from 'react';
import Tasks from './Tasks';
import Ideas from './Ideas';
import AgentLog from './AgentLog';
import Settings from './Settings';

const TABS = ['Tasks', 'Ideas', 'Agent Log', 'Settings'];

const styles = {
  container: { minHeight: '100vh', background: '#0f0f23' },
  header: {
    background: '#1a1a2e', borderBottom: '1px solid #2a2a4a',
    padding: '0 1.5rem', display: 'flex', alignItems: 'center',
    justifyContent: 'space-between', height: '56px',
  },
  title: { fontSize: '1.1rem', fontWeight: '700', color: '#e0e0e0', letterSpacing: '0.5px' },
  nav: { display: 'flex', gap: '0.25rem' },
  tabBtn: (active) => ({
    padding: '0.4rem 1rem', borderRadius: '6px', border: 'none',
    background: active ? '#4f46e5' : 'transparent',
    color: active ? '#fff' : '#999', cursor: 'pointer',
    fontWeight: active ? '600' : '400', fontSize: '0.9rem',
    transition: 'all 0.15s',
  }),
  userInfo: { display: 'flex', alignItems: 'center', gap: '0.75rem' },
  username: { color: '#666', fontSize: '0.85rem' },
  logoutBtn: {
    background: 'transparent', border: '1px solid #2a2a4a',
    borderRadius: '6px', color: '#999', cursor: 'pointer',
    padding: '0.3rem 0.75rem', fontSize: '0.8rem',
  },
  content: { padding: '1.5rem', maxWidth: '900px', margin: '0 auto' },
};

export default function Dashboard({ user, onLogout }) {
  const [activeTab, setActiveTab] = useState('Tasks');

  async function handleLogout() {
    await fetch('/api/auth/logout', { method: 'POST', credentials: 'same-origin' });
    onLogout();
  }

  return (
    <div style={styles.container}>
      <header style={styles.header}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '1.5rem' }}>
          <div style={styles.title}>Dashboard</div>
          <nav style={styles.nav}>
            {TABS.map(tab => (
              <button
                key={tab}
                style={styles.tabBtn(activeTab === tab)}
                onClick={() => setActiveTab(tab)}
              >
                {tab}
              </button>
            ))}
          </nav>
        </div>
        <div style={styles.userInfo}>
          <span style={styles.username}>{user}</span>
          <button style={styles.logoutBtn} onClick={handleLogout}>Logout</button>
        </div>
      </header>
      <main style={styles.content}>
        {activeTab === 'Tasks' && <Tasks />}
        {activeTab === 'Ideas' && <Ideas />}
        {activeTab === 'Agent Log' && <AgentLog />}
        {activeTab === 'Settings' && <Settings />}
      </main>
    </div>
  );
}
